import { render, staticRenderFns } from "./MercadoPago.vue?vue&type=template&id=3187d5e0&scoped=true&"
import script from "./MercadoPago.vue?vue&type=script&lang=js&"
export * from "./MercadoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187d5e0",
  null
  
)

export default component.exports